<!--
 * @Author: AnNa
 * @Date: 2021-02-18 16:17:33
 * @LastEditors: AnNa
 * @LastEditTime: 2021-03-11 10:25:56
 * @Description: 
-->
<template>
  <a-modal
    title="发送消息"
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <a-alert
        style="margin-bottom: 15px"
        message="此发送方式，无消息时间间隔，不要勾选太多同时发送"
        type="warning"
      ></a-alert>
      <a-form-item label="消息类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-decorator="['type', { initialValue: '1' }]">
          <a-select-option value="1">文本类型</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="消息内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea
          placeholder="请输入"
          :rows="4"
          v-decorator="['content', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSeccess" :loading="confirmLoading">发送</a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      mdl: {},
      visible: false,
      form: this.$form.createForm(this),
      wxids: [],
      robotid: null,
      confirmLoading: false,
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show({ robotid, wxids }) {
      this.visible = true
      this.robotid = robotid
      this.wxids = wxids
      // console.log(wxids)
    },
    handleCancel() {
      this.visible = false
    },
    handleSeccess() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const robotid = this.robotid
          const wxids = this.wxids
          // console.log(wxids)
          this.confirmLoading = true
          const data = {
            user: wxids,
            msg_type: values.type,
            msg_content: values.content,
          }
          this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: robotid,
            type: 'sendmsg',
            data: data,
          })
            .then((result) => {
              this.$message.success('发送指令成功')
              this.visible = false
              this.confirmLoading = false
              this.$emit('ok', values)
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>
<style lang="less">
</style>
